import { SnackbarProvider } from 'notistack';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import backend from './api';
import { useDispatch } from 'react-redux';
import { setUserData } from './redux-store/auth/actions';
import { ScrollToTop } from './Hooks/usePreventScrolling';
import { useSelector } from 'react-redux';
import './App.css'



// Logout out Routes
import Home from './MainWebsite/Pages/Home/Home';
import Signup from './MainWebsite/Pages/Signup/Signup';
import Login from './MainWebsite/Pages/Login/Login';
import Join from './MainWebsite/Pages/Join/Join';
import OnboardMentor from './MainWebsite/Pages/ProfileBuilder/Mentor/Mentor';
import OnboardMentee from './MainWebsite/Pages/ProfileBuilder/Mentee/Mentee';
import ContactUs from './MainWebsite/Pages/ContactUs/ContactUs';
import PrivacyPolicy from './MainWebsite/Pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './MainWebsite/Pages/TermsOfService/TermsOfService';
import DataSecurity from './MainWebsite/Pages/DataSecurity/DataSecurity';

// Mentor pages
import MentorMainLayout from './Panels/Mentor/MainLayout/MainLayout';
import MentorDashboard from './Panels/Mentor/Pages/Activity/Dashboard/Dashboard';
import MentorMeetings from './Panels/Mentor/Pages/Activity/Meetings/Meetings';
import MentorSettings from './Panels/Mentor/Pages/Account/Settings/Settings';
import MentorProfile from './Panels/Mentor/Pages/Profile/Profile/Profile';
import MentorMessages from './Panels/Mentor/Pages/Activity/Messages/Messages';
import MentorViewProfile from './Panels/Mentor/Pages/Others/MentorViewProfile/MentorViewProfile';
import MentorAvailability from './Panels/Mentor/Pages/Activity/Availability/Availibility';

// Mentee pages
import MenteeMainLayout from './Panels/Mentee/MainLayout/MainLayout';
import MenteeDashboard from './Panels/Mentee/Pages/Activity/Dashboard/Dashboard';
import MenteeMeetings from './Panels/Mentee/Pages/Activity/Meetings/Meetings';
import MenteeSettings from './Panels/Mentee/Pages/Account/Settings/Settings';
import MenteeProfile from './Panels/Mentee/Pages/Profile/Profile/Profile';
import MenteeMentors from './Panels/Mentee/Pages/Activity/Mentors/Mentors';
import MenteeMessages from './Panels/Mentee/Pages/Activity/Messages/Messages';
import MenteeViewProfile from './Panels/Mentee/Pages/Others/MenteeViewProfile/MenteeViewProfile';


const RenderRouterWithMenuFooter = (Component) => (
  <>
    <Component />
  </>
);

const MainWebsiteLoggedOutRoutes = () => (
  <>
    <Routes>
      <Route path='/' element={RenderRouterWithMenuFooter(Home)} ></Route>
      <Route path='/join' element={<Join />} />
      <Route path='/join/:role' element={<Signup />} />
      <Route path='/signup' element={<Signup />} />
      <Route path='/login' element={<Login />} />
      <Route path='/onboard/mentor' element={<OnboardMentor />} />
      <Route path='/onboard/mentee' element={<OnboardMentee />} />
      <Route path='/contact-us' element={<ContactUs />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/terms-of-service' element={<TermsOfService />} />
      <Route path='/data-security' element={<DataSecurity />} />

      <Route path='*' element={RenderRouterWithMenuFooter(Home)} ></Route>
    </Routes>
  </>
)


const MentorWithSideBar = (Component) => (
  <MentorMainLayout component={<Component />} />
);

const MentorLoggedInRoutes = () => (
  <Routes>
    <Route path="/" element={MentorWithSideBar(MentorDashboard)} />
    <Route path="/meetings" element={MentorWithSideBar(MentorMeetings)} />
    <Route path="/availability" element={MentorWithSideBar(MentorAvailability)} />

    <Route path="/mentee/view-profile/:id" element={MentorWithSideBar(MenteeViewProfile)} />
    <Route path="/messages" element={MentorWithSideBar(MentorMessages)} />
    <Route path="/messages/:userId" element={MentorWithSideBar(MentorMessages)} />

    <Route path="/profile" element={MentorWithSideBar(MentorProfile)} />

    <Route path="/settings" element={MentorWithSideBar(MentorSettings)} />
    <Route path='/contact-us' element={<ContactUs />} />
    <Route path="*" element={MentorWithSideBar(MentorDashboard)} />
  </Routes>
);

const MenteeWithSideBar = (Component) => (
  <MenteeMainLayout component={<Component />} />
);

const MenteeLoggedInRoutes = () => (
  <Routes>
    <Route path="/" element={MenteeWithSideBar(MenteeDashboard)} />
    <Route path="/meetings" element={MenteeWithSideBar(MenteeMeetings)} />
    <Route path="/mentor/view-profile/:id" element={MenteeWithSideBar(MentorViewProfile)} />

    <Route path="/mentors" element={MenteeWithSideBar(MenteeMentors)} />
    <Route path="/messages" element={MenteeWithSideBar(MenteeMessages)} />
    <Route path="/messages/:userId" element={MentorWithSideBar(MentorMessages)} />


    <Route path="/profile" element={MenteeWithSideBar(MenteeProfile)} />

    <Route path="/settings" element={MenteeWithSideBar(MenteeSettings)} />
    <Route path='/contact-us' element={<ContactUs />} />
    <Route path="*" element={MenteeWithSideBar(MenteeDashboard)} />
  </Routes>
);

const MenteeNotOnboardedInRoutes = () => (
  <Routes>
    <Route path="/" element={<OnboardMentee />} />
    <Route path='/onboard/mentee' element={<OnboardMentee />} />
  </Routes>
);

const MentorNotOnboardedInRoutes = () => (
  <Routes>
    <Route path="/" element={<OnboardMentor />} />
    <Route path='/onboard/mentor' element={<OnboardMentor />} />
  </Routes>
);


function AppRoutes() {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      const userId = user?._id;
      const fetchUser = async () => {
        const res = await backend.get(`/api/user/${userId}`);
        const updated = { ...user, ...res.data.data };
        await dispatch(setUserData(updated));
      }
      fetchUser();
    }
  }, [])

  return (
    <>
      <BrowserRouter>
        <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
          <ScrollToTop />
          {/* <MainWebsiteLoggedOutRoutes /> */}
          {user && user.role === "mentor" && user.onboarded === true ?
            <MentorLoggedInRoutes /> :
            user && user.role === "mentor" && user.onboarded === false? <MentorNotOnboardedInRoutes />
              : user && user.role === "mentee" && user.onboarded === true ?
                <MenteeLoggedInRoutes /> :
                user && user.role === "mentee" && user.onboarded === false ?
                  <MenteeNotOnboardedInRoutes /> :
                  <MainWebsiteLoggedOutRoutes />
          }
        </SnackbarProvider>
      </BrowserRouter>
    </>
  );
}

export default AppRoutes;
